var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 2.4,
    fill: "#fff",
    width: 2.3,
    height: 11.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 2.5,
    fill: "#fff",
    width: 5.5,
    height: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3,4.7h-2v2.7h2c0.7,0,1.3-0.6,1.3-1.3S10.1,4.7,9.3,4.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8C16,3.6,12.4,0,8,0z M9.3,9.3h-2v4h-2V2.7h4c1.8,0,3.3,1.5,3.3,3.3 S11.2,9.3,9.3,9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.80643ba0f176f3fc3fa281922c46e8a1.svg";
export { ForwardRef as ReactComponent };